import { Flex, Skeleton } from '@mantine/core';
import { useRouter } from 'next/router';

import { useQueryGetInquiryById } from '@flecto/core/saas';
import { useTranslation } from '@flecto/translations';
import { Page } from '@flecto/ui/saas';

import { BadgeInquiryStatus } from '../components/BadgeInquiryStatus/BadgeInquiryStatus';
import { CardInquiryCustomer } from '../components/CardInquiryCustomer/CardInquiryCustomer';
import { CardInquiryNotes } from '../components/CardInquiryNotes/CardInquiryNotes';
import { CardInquiryProducts } from '../components/CardInquiryProducts/CardInquiryProducts';
import { CardInquiryRangeDates } from '../components/CardInquiryRangeDates/CardInquiryRangeDates';
import { CardInquirySummary } from '../components/CardInquirySummary/CardInquirySummary';
import { HeaderActions } from '../components/HeaderActions/HeaderActions';

export function PageInquiryDetails() {
  const router = useRouter()
  const inquiryId = Number(router.query.id)

  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const { data, isLoading } = useQueryGetInquiryById({ inquiryId })

  const inquiry = data?.inquiry

  return (
    <Page withLoading={isLoading} withContainer>
      <Page.Close onClick={() => router.push('/inquiries')} />
      <Page.Title>
        {isLoading ? <Skeleton h={20} w={200} /> :
          <Flex align='center' gap='sm'>
            {t('request', { replace: { id: inquiry?.internal_id } })}
            <BadgeInquiryStatus inquiry={inquiry} />
          </Flex>
        }
      </Page.Title>
      <Page.Actions>
        {!isLoading && <HeaderActions inquiryId={inquiryId} />}
      </Page.Actions>
      <Page.Content>
        <Flex direction='column' gap='lg'>
          <CardInquirySummary inquiryId={inquiryId} />
          <CardInquiryRangeDates inquiryId={inquiryId} />
          <CardInquiryCustomer inquiryId={inquiryId} />
          <CardInquiryNotes inquiryId={inquiryId} />
          <CardInquiryProducts inquiryId={inquiryId} />
        </Flex>
      </Page.Content>
    </Page>
  )
}
